import React from "react"
import { Box } from "@chakra-ui/react"
import Image from "@app/components/Image/Image"
import TileCarousel from "@app/components/TileCarousel/TileCarousel"
import { useMedia } from "@app/hooks/useMedia"

export interface ProductMediaMobileProps {
  images: any[]
  carouselSettings?: GatsbyTypes.SanityCarouselSettings
  onOpen: () => void
}

const ProductMediaMobile = ({ images, carouselSettings, onOpen }: ProductMediaMobileProps) => {
  const { isBase } = useMedia()

  return images.length > 1 ? (
    <TileCarousel carouselSettings={carouselSettings}>
      {images.map((image: any, index: number) => (
        <Box mb={isBase ? undefined : 2.5} key={index} onClick={onOpen}>
          <Image src={image?.src} alt={image?.alt} objectFit="cover" w="298px" h="387px" />
        </Box>
      ))}
    </TileCarousel>
  ) : (
    <Image src={images?.[0]?.src} alt={images?.[0]?.alt} objectFit="cover" />
  )
}

export default ProductMediaMobile
